import { render, staticRenderFns } from "./AccidentIntakeDailyActivitiesForm.vue?vue&type=template&id=74f2d008&scoped=true"
import script from "./AccidentIntakeDailyActivitiesForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeDailyActivitiesForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeDailyActivitiesForm.vue?vue&type=style&index=0&id=74f2d008&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f2d008",
  null
  
)

export default component.exports